<template>
      <div no-body class="lku-advpay"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else class="ml-3 mr-3">
        <b-col lg="10">
            <b-input-group >
                <b-input-group-prepend><label >Advance Owner</label></b-input-group-prepend>
                <b-form-input v-model="tblData.crewinfo" placeholder="Name" :disabled="((tblData.crewkey||'') !== '')" @keyup.13.native="refresh()"></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-1">Currency</span></b-input-group-prepend>
                <select  v-model="tblData.matauang"  style="width:120px;">
                    <option v-for="row in currencies" :key="row.value" :value="row.value">{{row.text}}</option>
                    <option value="">-ALL-</option>
                </select>
            </b-input-group>
              <b-row>
                <b-col md="5">
                  <b-input-group >
                      <b-input-group-prepend><label>Advance Number </label></b-input-group-prepend>
                        <b-form-input v-model="tblData.nomorPaym" @keyup.13.native="refresh()" placeholder="Advance Number"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col md="7">
                  <b-input-group >
                      <b-input-group-prepend><span class="mt-2" >Description</span></b-input-group-prepend>                  
                        <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" placeholder="Description"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>       
        </b-col>
        <b-col lg="2">
                  <b-button variant="success" style="width:120px;" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary" style="width:120px;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="tblAdvPay" style="font-size:smaller;" 
        responsive small striped hover
        :items="tblData.items"
        :fields="fields"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="updatetable" 
        @row-clicked="selectItem"
        @sort-changed="sortingChanged"
      >
        <template v-slot:cell(tglPaym)="data">
          {{ data.item.tglPaym | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(nomor)="data">
          {{ data.item.nomor}}<br>{{data.item.nomorPaym}}
        </template>
          <template v-slot:cell(nilaiByr)="data">
              {{data.item.nilaiByr | numFormat}}
          </template>

          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

  </div>
</template>
<style lang="scss">
  .lku-advpay {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import advance from "../../apis/advance";

export default {
  data() {
    return {
      lkuLoading:false,
      currencies:[],
      fields: [
          {
            key: "tglPaym",
            thStyle: "width:90px",
            label: "Payment Date",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true

          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Owner",
            sortable: true
          },
          {
            key: "nomor",
            label: "Request# | Payment# ",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilaiByr",
            label: "Payment Amount",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Un-Settle Amount",
            thStyle: "width:130px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'tglPaym',
        sortDesc: true,
        crewkey:'',
        outstand : '1'
      },
      updatetable:false
    };
  },
  computed: {
    filterCrewinfo() {
      return this.tblData.crewinfo;
    },
    filterCrewkey() {
      return this.tblData.crewkey;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
    filteMatauang() {
      return this.tblData.matauang;
    },
  },
  watch: {
    filterMatauang: function(newval) {
      this.$emit('update:matauang', newval);
    },    
    filterCrewinfo: function(newval) {
      this.$emit('update:crewinfo', newval);
    },    
    filterCrewkey: function(newval) {
      this.$emit('update:crewkey', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  props: ["crewinfo", "crewkey","formdata","matauang"],
  created: async function() {
    this.currencies = await advance.currency();
      this.tblData.crewinfo=this.crewinfo || '';
      this.tblData.crewkey=this.crewkey || '';
      this.tblData.matauang=this.matauang || '';
      if (this.crewkey) {
        if (this.formdata.items)
        {
          if (this.formdata.items[0].crewkey!==this.crewkey) {
            this.data();
          } else {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
          }
        } else {
          this.data();
        }
      } else {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        }
      }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await advance.listpaid(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        // this.crewinfo= '';
        // this.crewkey=  '';
        // this.tblData.crewinfo= '';
        // this.tblData.crewkey=  '';
        this.tblData.uraian=  '';
        this.tblData.nomorPaym=  '';
        this.tblData.matauang=  '';        
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblAdvPay.refresh();
       }
    },    
    sortingChanged: function(ctx) {
      setTimeout(() => {
        this.refresh();
      }, 100);
    },
    refresh() {
      this.data();
      this.$refs.tblAdvPay.refresh();
    }
  }
};
</script>
